const $ = jQuery.noConflict()

var self = module.exports = {
  init: function(trigger) {
    self.events.click(trigger)
  },

  events: {
    click: function(trigger) {
      $(trigger).on('click', function() {
        self.service.disableSiblings($(this))
        self.service.activateTab($(this))
      });
    },
  },

  service: {
    disableSiblings: function(target) {
    
    },
    activateTab: function(target) {
      $('.process__tabs .process__tab').not($(target)).removeClass('active');
      $(target).toggleClass('active');
    },
  }
}
 